import React from "react"
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import logo from "../../../../common/src/assets/img/brand/logo.svg"

const Drawer = () => {
    const {t} = useTranslation();
    return (
        <aside className="aside is-placed-left is-expanded">
            <div className='logo-container'>
                <img src={logo} alt="Logo"/>
            </div>

            <div className="menu is-menu-main">
                    <p className="menu-label">{t("datasets")}</p>
                    <ul className="menu-list">
                        <li>
                            <NavLink to="/">
                                <span className="icon"><i className="fz fz-binoculars"/></span>
                                <span
                                    className="menu-item-label">{t('drawer.datasets')}</span>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to="/instructions">
                                <span className="icon"><i className="fz fz-desktop"/></span>
                                <span
                                    className="menu-item-label">{t('drawer.instructions')}</span>
                            </NavLink>
                        </li>
                    </ul>
            </div>
        </aside>
    )
}

export default Drawer
